"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Dialog: true
};
exports.default = exports.Dialog = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("react-overlays/Modal"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _IconButton = require("../IconButton/IconButton");
var _Title = require("../Title/Title");
var _Toolbar = require("../Toolbar/Toolbar");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _clamp = require("../utils/_clamp");
var _focusManager = require("../utils/focusManager");
var _useModalManager = require("../utils/useModalManager");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useResizeObserver = require("../utils/useResizeObserver");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _isFunction = require("../utils/isFunction");
var _DialogTransition = require("./_DialogTransition");
var _DialogResizeHandle = require("./_DialogResizeHandle");
var _Dialog = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Dialog.css") : void 0);
var _Dialog2 = require("./Dialog.types");
Object.keys(_Dialog2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Dialog2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Dialog2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable @typescript-eslint/ban-ts-comment */

const CSS_BLOCK = 'sapcnqr-dialog';
const MOVEMENT_STEP_SIZE = 16;
/**
 * The **Dialog** component is overlaid on top of the page. This allows the user
 * to focus on specific content before returning to the underlying application page.
 */
const Dialog = exports.Dialog = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _a, _b, _c, _d;
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const _e = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(Dialog, props)) : props,
    {
      additionalTitleContentStart,
      additionalTitleContentEnd,
      backdropProps,
      bodyProps,
      children,
      className,
      containerProps,
      dimensions,
      draggable,
      firstFocusRef,
      footer,
      footerProps,
      fullscreen,
      fullscreenToggle,
      canOpenDialog,
      headerProps,
      onHide,
      onShow,
      resizable,
      show,
      widthSize,
      subheader,
      subheaderContainerProps,
      subheaderProps,
      title,
      titleContainerProps,
      titleContentStartContainerProps,
      titleContentEndContainerProps,
      titleProps,
      titleIcon,
      hideHeader
    } = _e,
    otherProps = __rest(_e, ["additionalTitleContentStart", "additionalTitleContentEnd", "backdropProps", "bodyProps", "children", "className", "containerProps", "dimensions", "draggable", "firstFocusRef", "footer", "footerProps", "fullscreen", "fullscreenToggle", "canOpenDialog", "headerProps", "onHide", "onShow", "resizable", "show", "widthSize", "subheader", "subheaderContainerProps", "subheaderProps", "title", "titleContainerProps", "titleContentStartContainerProps", "titleContentEndContainerProps", "titleProps", "titleIcon", "hideHeader"]);
  const {
    ariaLabel: footerAriaLabel,
    mainContent,
    mainRegionProps,
    alternateContent,
    alternateRegionProps,
    toolbarProps
  } = footer || {};
  const classnames = _bind.default.bind(_Dialog.default);
  const [focusManager, setFocusManager] = (0, _react.useState)();
  const modalManager = (0, _useModalManager.useModalManager)();
  const modalRef = (0, _react.useRef)(null);
  const mergedRef = (0, _reactMergeRefs.default)([ref, modalRef]);
  const [isFullscreen, setIsFullscreen] = (0, _react.useState)(!!fullscreen);
  const [isDragging, setIsDragging] = (0, _react.useState)(false);
  const [isStackedFooter, setIsStackedFooter] = (0, _react.useState)(false);
  const [position, setPosition] = (0, _react.useState)({
    startX: 0,
    startY: 0,
    startLeft: 0,
    startLeftEdge: 0,
    startRightEdge: 0,
    startTopEdge: 0,
    startBottomEdge: 0,
    x: 0,
    y: 0,
    pageX: 0
  });
  const containerRef = (0, _react.useRef)(null);
  const headerRef = (0, _react.useRef)(null);
  const titleRef = (0, _react.useRef)(null);
  const subheaderRef = (0, _react.useRef)(null);
  const bodyRef = (0, _react.useRef)(null);
  const footerRef = (0, _react.useRef)(null);
  const contentClientRect = () => {
    var _a;
    return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
  };
  const getContentTop = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.top) || 0;
  };
  const getContentBottom = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.bottom) || 0;
  };
  const getContentLeft = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.left) || 0;
  };
  const getContentRight = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.right) || 0;
  };
  const getContentHeight = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.height) || 0;
  };
  const getContentWidth = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.width) || 0;
  };
  const getContentX = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.x) || 0;
  };
  const getContentY = () => {
    var _a;
    return ((_a = contentClientRect()) === null || _a === void 0 ? void 0 : _a.y) || 0;
  };
  const updatePosition = styleValue => {
    if (containerRef.current) {
      containerRef.current.style.top = styleValue.top;
      containerRef.current.style.left = styleValue.left;
    }
  };
  const updateSize = styleValue => {
    if (bodyRef.current) {
      bodyRef.current.style.height = styleValue.height;
      bodyRef.current.style.width = styleValue.width;
    }
    if (footerRef.current) {
      footerRef.current.style.width = styleValue.width;
    }
  };
  const instructionsId = (0, _useUniqueId.default)();
  let titleId = (0, _useUniqueId.default)();
  if (titleProps === null || titleProps === void 0 ? void 0 : titleProps.id) {
    titleId = titleProps.id;
  }
  let subheaderId = (0, _useUniqueId.default)();
  if (subheaderProps === null || subheaderProps === void 0 ? void 0 : subheaderProps.id) {
    subheaderId = subheaderProps.id;
  }
  const baseTransitionProps = {
    className: classnames(`${CSS_BLOCK}__fade`),
    timeout: 150,
    transitionStyles: {
      entering: classnames(`${CSS_BLOCK}__fade--in`),
      entered: classnames(`${CSS_BLOCK}__fade--in`)
    }
  };
  const dialogTransitionRef = (0, _react.useRef)(transitionProps => (/*#__PURE__*/_react.default.createElement(_DialogTransition.DialogTransition, Object.assign({}, baseTransitionProps, transitionProps))));
  const backdropTransitionRef = (0, _react.useRef)(transitionProps => (/*#__PURE__*/_react.default.createElement(_DialogTransition.DialogTransition, Object.assign({}, baseTransitionProps, transitionProps))));
  const onMouseDown = (0, _react.useCallback)(e => {
    var _a, _b, _c;
    (_a = e === null || e === void 0 ? void 0 : e.persist) === null || _a === void 0 ? void 0 : _a.call(e);
    if (e.button !== 0 || ((_b = titleRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)) || ((_c = subheaderRef.current) === null || _c === void 0 ? void 0 : _c.contains(e.target))) {
      return;
    }
    if ((0, _isFunction.isFunction)(draggable === null || draggable === void 0 ? void 0 : draggable.onDragStart)) {
      draggable.onDragStart(e);
    }
    setIsDragging(true);
    setPosition(prevState => Object.assign(Object.assign({}, prevState), {
      startX: e.pageX - prevState.x,
      startY: e.clientY - prevState.y,
      startLeft: containerRef.current && parseInt(window.getComputedStyle(containerRef.current).getPropertyValue('left').replace('px', ''), 10),
      startLeftEdge: getContentX(),
      startRightEdge: getContentX() + getContentWidth(),
      startTopEdge: getContentY(),
      startBottomEdge: getContentY() + getContentHeight(),
      pageX: e.pageX,
      clientY: e.clientY
    }));
  }, []);
  const onKeyDown = (0, _react.useCallback)(e => {
    var _a;
    (_a = e === null || e === void 0 ? void 0 : e.persist) === null || _a === void 0 ? void 0 : _a.call(e);
    const moveStepSize = e.shiftKey ? 5 * MOVEMENT_STEP_SIZE : MOVEMENT_STEP_SIZE;
    switch (e.keyCode) {
      case _keycode.default.codes.left:
        e.preventDefault();
        if (getContentLeft() > 0) {
          setPosition(prevState => {
            const newLeft = prevState.x - Math.min(moveStepSize, getContentLeft());
            updatePosition({
              top: `${prevState.y}px`,
              left: `${newLeft}px`
            });
            return Object.assign(Object.assign({}, prevState), {
              x: newLeft
            });
          });
        }
        break;
      case _keycode.default.codes.right:
        e.preventDefault();
        if (getContentRight() < window.innerWidth) {
          setPosition(prevState => {
            const newLeft = prevState.x + Math.min(moveStepSize, window.innerWidth - getContentRight());
            updatePosition({
              top: `${prevState.y}px`,
              left: `${newLeft}px`
            });
            return Object.assign(Object.assign({}, prevState), {
              x: newLeft
            });
          });
        }
        break;
      case _keycode.default.codes.up:
        e.preventDefault();
        if (getContentTop() > 0) {
          setPosition(prevState => {
            const newTop = prevState.y - Math.min(moveStepSize, getContentTop());
            updatePosition({
              top: `${newTop}px`,
              left: `${prevState.x}px`
            });
            return Object.assign(Object.assign({}, prevState), {
              y: newTop
            });
          });
        }
        break;
      case _keycode.default.codes.down:
        e.preventDefault();
        if (getContentBottom() < window.innerHeight) {
          setPosition(prevState => {
            const newTop = prevState.y + Math.min(moveStepSize, window.innerHeight - getContentBottom());
            updatePosition({
              top: `${newTop}px`,
              left: `${prevState.x}px`
            });
            return Object.assign(Object.assign({}, prevState), {
              y: newTop
            });
          });
        }
        break;
      default:
    }
    if ((0, _isFunction.isFunction)(draggable === null || draggable === void 0 ? void 0 : draggable.onKeyDown)) {
      draggable.onKeyDown(e);
    }
  }, []);
  const classes = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--width-${widthSize}`]: !!widthSize,
    [`${CSS_BLOCK}--fullscreen`]: isFullscreen
  });
  const backdropClasses = classnames(`${CSS_BLOCK}__backdrop`, backdropProps === null || backdropProps === void 0 ? void 0 : backdropProps.className, {
    [`${CSS_BLOCK}__backdrop--fullscreen`]: isFullscreen
  });
  const baseModalContainerClasses = classnames(`${CSS_BLOCK}__open`);
  const containerClasses = classnames(`${CSS_BLOCK}__container`, containerProps === null || containerProps === void 0 ? void 0 : containerProps.className);
  const headerClasses = classnames(`${CSS_BLOCK}__header`, headerProps === null || headerProps === void 0 ? void 0 : headerProps.className, {
    [`${CSS_BLOCK}__header--draggable`]: !!draggable,
    [`${CSS_BLOCK}__header--dragging`]: isDragging
  });
  const titleContainerClasses = classnames(`${CSS_BLOCK}__title-container`, titleContainerProps === null || titleContainerProps === void 0 ? void 0 : titleContainerProps.className);
  const titleContentStartContainerClasses = classnames(`${CSS_BLOCK}__title-content-container`, titleContentStartContainerProps === null || titleContentStartContainerProps === void 0 ? void 0 : titleContentStartContainerProps.className);
  const titleContentEndContainerClasses = classnames(`${CSS_BLOCK}__title-content-container`, titleContentEndContainerProps === null || titleContentEndContainerProps === void 0 ? void 0 : titleContentEndContainerProps.className);
  const titleClasses = classnames(`${CSS_BLOCK}__title`, titleProps === null || titleProps === void 0 ? void 0 : titleProps.className);
  const subheaderContainerClasses = classnames(`${CSS_BLOCK}__subheader-container`, subheaderContainerProps === null || subheaderContainerProps === void 0 ? void 0 : subheaderContainerProps.className);
  const subheaderClasses = classnames(`${CSS_BLOCK}__subheader`, subheaderProps === null || subheaderProps === void 0 ? void 0 : subheaderProps.className);
  const footerClasses = classnames(`${CSS_BLOCK}__footer`, footerProps === null || footerProps === void 0 ? void 0 : footerProps.className);
  const bodyClasses = classnames(`${CSS_BLOCK}__body`, bodyProps === null || bodyProps === void 0 ? void 0 : bodyProps.className, {
    [`${CSS_BLOCK}__body--subheader`]: !!subheader
  });
  const toolbarClasses = classnames(`${CSS_BLOCK}__toolbar`, toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.className);
  const mainRegionClasses = classnames(`${CSS_BLOCK}__toolbar-main`, mainRegionProps === null || mainRegionProps === void 0 ? void 0 : mainRegionProps.className);
  const attachFocusManager = ({
    suppressInitialAttachment = true,
    firstFocusIndex = undefined
  } = {}) => {
    const {
      dialog
    } = modalRef.current || {};
    // eslint-disable-next-line no-new
    setFocusManager(new _focusManager.FocusManager({
      trapNode: dialog,
      suppressInitialAttachment,
      firstFocusIndex
    }));
  };
  const detachFocusManager = () => {
    focusManager === null || focusManager === void 0 ? void 0 : focusManager.detach();
    setFocusManager(null);
  };
  (0, _useUniversalLayoutEffect.default)(() => {
    var _a;
    if (show) {
      (_a = firstFocusRef === null || firstFocusRef === void 0 ? void 0 : firstFocusRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    } else {
      setPosition({
        startX: 0,
        startY: 0,
        startLeft: 0,
        startLeftEdge: 0,
        startRightEdge: 0,
        startTopEdge: 0,
        startBottomEdge: 0,
        x: 0,
        y: 0,
        pageX: 0
      });
    }
  }, [show, firstFocusRef]);
  (0, _react.useEffect)(() => {
    const onMouseMove = e => {
      var _a;
      (_a = e === null || e === void 0 ? void 0 : e.persist) === null || _a === void 0 ? void 0 : _a.call(e);
      let xDisplacement = e.pageX - position.pageX;
      let yDisplacement = e.clientY - position.startY;
      xDisplacement = (0, _clamp.clamp)(xDisplacement, -position.startLeftEdge, window.innerWidth - position.startRightEdge);
      yDisplacement = (0, _clamp.clamp)(yDisplacement, -position.startTopEdge + position.y, window.innerHeight - position.startBottomEdge + position.y);
      const startLeft = position.startLeft + xDisplacement;
      updatePosition({
        top: `${yDisplacement}px`,
        left: `${startLeft}px`
      });
      setPosition(prevState => Object.assign(Object.assign({}, prevState), {
        x: startLeft,
        y: yDisplacement,
        pageX: e.pageX,
        clientY: e.clientY,
        startLeft
      }));
    };
    const onMouseUp = e => {
      var _a;
      (_a = e === null || e === void 0 ? void 0 : e.persist) === null || _a === void 0 ? void 0 : _a.call(e);
      setIsDragging(false);
      if ((0, _isFunction.isFunction)(draggable === null || draggable === void 0 ? void 0 : draggable.onDragEnd)) {
        draggable.onDragEnd(e);
      }
    };
    if (isDragging) {
      document.addEventListener('mouseup', onMouseUp);
      document.addEventListener('mousemove', onMouseMove);
    }
    return () => {
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
    };
  }, [isDragging]);
  (0, _react.useEffect)(() => {
    if (!draggable) return () => {};
    // try to keep the modal within the window when window resizes
    const handleWindowResize = () => {
      if (!containerRef.current) {
        return;
      }
      let skipLeftMovement;
      if (getContentWidth() >= window.innerWidth && getContentLeft() <= 0) {
        skipLeftMovement = true;
      }
      let newLeft = parseInt(window.getComputedStyle(containerRef.current).getPropertyValue('left').replace('px', ''), 10);
      let newTop = parseInt(window.getComputedStyle(containerRef.current).getPropertyValue('top').replace('px', ''), 10);
      if (window.innerWidth <= getContentRight() && getContentLeft() > 0) {
        newLeft -= getContentRight() - window.innerWidth;
      } else if (getContentLeft() < 0) {
        newLeft -= getContentLeft();
      }
      if (window.innerHeight <= getContentBottom() && getContentTop() > 0) {
        newTop -= getContentBottom() - window.innerHeight;
      }
      setPosition(prevState => {
        updatePosition({
          left: `${skipLeftMovement ? prevState.left : newLeft}px`,
          top: `${newTop}px`
        });
        return Object.assign(Object.assign({}, prevState), {
          x: newLeft,
          y: newTop
        });
      });
    };
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [draggable]);
  (0, _react.useEffect)(() => {
    setIsFullscreen(!!fullscreen);
  }, [fullscreen]);
  const {
    height: footerHeight,
    observeNewElement
  } = (0, _useResizeObserver.useResizeObserver)();
  (0, _react.useEffect)(() => {
    if (footerRef.current) {
      observeNewElement === null || observeNewElement === void 0 ? void 0 : observeNewElement(footerRef.current);
    }
  }, [footerRef.current]);
  const handleFullscreenToggleClick = event => {
    var _a;
    const newFullscreenValue = !isFullscreen;
    setIsFullscreen(newFullscreenValue);
    (_a = fullscreenToggle === null || fullscreenToggle === void 0 ? void 0 : fullscreenToggle.onToggle) === null || _a === void 0 ? void 0 : _a.call(fullscreenToggle, event, newFullscreenValue);
  };
  const adjustedHeaderProps = draggable ? Object.assign(Object.assign({}, headerProps), {
    onMouseDown,
    onKeyDown,
    role: 'button',
    tabIndex: 0,
    'aria-describedby': instructionsId
  }) : headerProps;
  const titleContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, titleIcon, /*#__PURE__*/_react.default.createElement(_Title.Title, Object.assign({
    headingLevel: 2,
    headingStyle: 5
  }, titleProps, {
    className: titleClasses,
    id: titleId,
    ref: (titleProps === null || titleProps === void 0 ? void 0 : titleProps.ref) ? (0, _reactMergeRefs.default)([titleProps === null || titleProps === void 0 ? void 0 : titleProps.ref, titleRef]) : titleRef
  }), title));
  const fullScreenToggleContent = fullscreenToggle && (/*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({}, fullscreenToggle === null || fullscreenToggle === void 0 ? void 0 : fullscreenToggle.buttonProps, {
    ariaLabel: isFullscreen ? fullscreenToggle.textExitFullscreen : fullscreenToggle.textEnterFullscreen,
    iconName: isFullscreen ? 'window-minimize' : 'window-maximize',
    onClick: handleFullscreenToggleClick
  })));
  const hiddenHeaderAriaLabel = (_b = (_a = hideHeader === null || hideHeader === void 0 ? void 0 : hideHeader.ariaLabel) === null || _a === void 0 ? void 0 : _a.trim) === null || _b === void 0 ? void 0 : _b.call(_a);
  const hiddenHeaderAriaLabelledBy = (_d = (_c = hideHeader === null || hideHeader === void 0 ? void 0 : hideHeader.ariaLabelledBy) === null || _c === void 0 ? void 0 : _c.trim) === null || _d === void 0 ? void 0 : _d.call(_c);
  const noHeader = hiddenHeaderAriaLabel || hiddenHeaderAriaLabelledBy;
  let hiddenProps = {};
  if (hiddenHeaderAriaLabel) {
    hiddenProps = {
      'aria-label': hiddenHeaderAriaLabel
    };
  } else if (hiddenHeaderAriaLabelledBy) {
    hiddenProps = {
      'aria-labelledby': hiddenHeaderAriaLabelledBy
    };
  }
  const renderDialog = dialogProps => {
    let ariaDescribedBy = (dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps['aria-describedby']) || '';
    if (subheader) {
      ariaDescribedBy = `${ariaDescribedBy} ${subheaderId}`.trim();
    }
    return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, dialogProps, {
      "aria-describedby": ariaDescribedBy
    }, noHeader ? hiddenProps : {
      'aria-labelledby': titleId
    }), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, containerProps, {
      className: containerClasses,
      ref: (containerProps === null || containerProps === void 0 ? void 0 : containerProps.ref) ? (0, _reactMergeRefs.default)([containerProps === null || containerProps === void 0 ? void 0 : containerProps.ref, containerRef]) : containerRef,
      style: Object.assign(Object.assign({}, containerProps === null || containerProps === void 0 ? void 0 : containerProps.style), {
        maxWidth: dimensions ? dimensions.maxWidth : undefined,
        minWidth: dimensions ? dimensions.minWidth : undefined
      })
    }), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, adjustedHeaderProps, {
      style: Object.assign(Object.assign({}, adjustedHeaderProps === null || adjustedHeaderProps === void 0 ? void 0 : adjustedHeaderProps.style), {
        maxWidth: dimensions ? dimensions.maxWidth : undefined,
        minWidth: dimensions ? dimensions.minWidth : undefined
      }),
      className: headerClasses,
      ref: (0, _reactMergeRefs.default)([headerProps === null || headerProps === void 0 ? void 0 : headerProps.ref, headerRef])
    }), draggable && (/*#__PURE__*/_react.default.createElement("span", {
      "aria-live": "polite",
      className: classnames(`${CSS_BLOCK}__screen-reader-only`),
      id: instructionsId
    }, draggable.screenReaderInstructions)), noHeader ? null : (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, titleContainerProps, {
      className: titleContainerClasses
    }), additionalTitleContentStart ? (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, titleContentStartContainerProps, {
      className: titleContentStartContainerClasses
    }), additionalTitleContentStart, titleContent)) : titleContent, additionalTitleContentEnd ? (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, titleContentEndContainerProps, {
      className: titleContentEndContainerClasses
    }), additionalTitleContentEnd, fullScreenToggleContent)) : fullScreenToggleContent)), subheader && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, subheaderContainerProps, {
      className: subheaderContainerClasses
    }), /*#__PURE__*/_react.default.createElement("span", Object.assign({}, subheaderProps, {
      className: subheaderClasses,
      id: subheaderId,
      ref: (subheaderProps === null || subheaderProps === void 0 ? void 0 : subheaderProps.ref) ? (0, _reactMergeRefs.default)([subheaderProps === null || subheaderProps === void 0 ? void 0 : subheaderProps.ref, subheaderRef]) : subheaderRef
    }), subheader)))), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, bodyProps, {
      className: bodyClasses,
      ref: (bodyProps === null || bodyProps === void 0 ? void 0 : bodyProps.ref) ? (0, _reactMergeRefs.default)([bodyProps === null || bodyProps === void 0 ? void 0 : bodyProps.ref, bodyRef]) : bodyRef,
      style: Object.assign(Object.assign(Object.assign({}, bodyProps === null || bodyProps === void 0 ? void 0 : bodyProps.style), (() => {
        if (dimensions) {
          return {
            maxHeight: dimensions.maxHeight,
            maxWidth: dimensions.maxWidth,
            minWidth: dimensions.minWidth
          };
        }
        if (footerHeight !== undefined) {
          return {
            maxHeight: `calc(88vh - var(--nw_Dialog_Header_Height) - ${footerHeight}px)`
          };
        }
        return {};
      })()), {
        minHeight: dimensions ? dimensions.minHeight : undefined
      })
    }), children), footer && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, footerProps, {
      className: footerClasses,
      ref: (footerProps === null || footerProps === void 0 ? void 0 : footerProps.ref) ? (0, _reactMergeRefs.default)([footerProps === null || footerProps === void 0 ? void 0 : footerProps.ref, footerRef]) : footerRef,
      style: Object.assign(Object.assign(Object.assign({}, footerProps === null || footerProps === void 0 ? void 0 : footerProps.style), {
        maxWidth: dimensions ? dimensions.maxWidth : undefined,
        minWidth: dimensions ? dimensions.minWidth : undefined
      }), isStackedFooter ? {
        height: 'auto',
        flexDirection: 'column'
      } : {})
    }), /*#__PURE__*/_react.default.createElement(_Toolbar.Toolbar, Object.assign({
      navigationType: "tabKeyOnly",
      toolbarStyle: "transparent"
    }, toolbarProps, {
      autoStack: true,
      className: toolbarClasses,
      ariaLabel: footerAriaLabel || '',
      onStackedChange: isStacked => {
        var _a;
        setIsStackedFooter(isStacked);
        if ((focusManager === null || focusManager === void 0 ? void 0 : focusManager.focusedIndex) !== undefined) {
          attachFocusManager({
            suppressInitialAttachment: false,
            firstFocusIndex: focusManager === null || focusManager === void 0 ? void 0 : focusManager.focusedIndex
          });
        } else {
          (_a = firstFocusRef === null || firstFocusRef === void 0 ? void 0 : firstFocusRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
      }
    }), alternateContent && (/*#__PURE__*/_react.default.createElement(_Toolbar.Toolbar.Start, Object.assign({}, alternateRegionProps), alternateContent)), mainContent && (/*#__PURE__*/_react.default.createElement(_Toolbar.Toolbar.End, Object.assign({}, mainRegionProps, {
      className: mainRegionClasses
    }), mainContent))))), resizable && !isFullscreen && (/*#__PURE__*/_react.default.createElement(_DialogResizeHandle.DialogResizeHandle, Object.assign({}, resizable, {
      containerRef: bodyRef,
      updateSize: updateSize
    })))));
  };
  const renderBackdrop = modalBackdropProps => (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, modalBackdropProps, backdropProps, {
    className: backdropClasses
  })));
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: () => ({
      'data-skip-toolbar': true
    })
  }, /*#__PURE__*/_react.default.createElement(_Modal.default, Object.assign({}, otherProps, {
    backdrop: "static",
    backdropTransition: backdropTransitionRef.current,
    className: classes,
    containerClassName: baseModalContainerClasses,
    enforceFocus: !canOpenDialog,
    manager: modalManager,
    onHide: (0, _chainFunction.default)(detachFocusManager, onHide),
    onShow: (0, _chainFunction.default)(attachFocusManager, onShow),
    ref: mergedRef,
    renderBackdrop: renderBackdrop,
    renderDialog: renderDialog,
    show: show,
    transition: dialogTransitionRef.current
  })));
});
Dialog.displayName = 'Dialog';
var _default = exports.default = Dialog;